import {Link} from "react-router-dom";
import React from "react";
import {Team} from "./types";

type RankingTableProps = {
    teams: Team[],
    groupId: string
}

export const RankingTable: React.FC<RankingTableProps> = ({teams, groupId}) => {
    return (
        <>
            <table className="ranking">
                <thead>
                <th></th>
                <th></th>
                <th>Sp.</th>
                <th>S</th>
                <th>U</th>
                <th>N</th>
                <th>Körbe</th>
                <th>+/-</th>
                <th>Pkt.</th>
                </thead>
                <tbody>
                {teams.map(element =>
                    <tr key={"key_" + element.teamId}>
                        <td>{element.rank}</td>
                        <td className="team"><Link to={'/group/' + groupId + '/team/' + element.teamId}>{element.team}</Link></td>
                        <td>{element.played}</td>
                        <td>{element.won}</td>
                        <td>{element.tie}</td>
                        <td>{element.lost}</td>
                        <td className="rate">{element.rate[0]}:{element.rate[1]}</td>
                        <td>{element.rate[0] - element.rate[1]}</td>
                        <td>{element.points}</td>
                    </tr>
                )}
                </tbody>
            </table>
        </>
    );
}